import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { CardLoadingItemDesktop } from './desktop';
import { CardLoadingItemMobile } from './mobile';

export const CardLoadingItem: React.FC = () => {
  return useBreakpointValue({
    base: <CardLoadingItemMobile />,
    sm: <CardLoadingItemDesktop />,
  });
};
